/**
 * Summary: Request login code via Email for specified user.
 *
 * Tags: Ui
 */
import { AxiosRequestConfig } from "axios";

import { httpPost } from "shared/api/apiHandler";

export const API_POST_UI_REQUEST_EMAIL_LOGIN_CODE_URL = "api/v1/ui/request-email-login-code";

export const apiPostUiRequestEmailLoginCode = async (
    request?: ApiPostUiRequestEmailLoginCodeRequest,
    config?: AxiosRequestConfig
): Promise<ApiPostUiRequestEmailLoginCodeResponse> => {
    const result = await httpPost<ApiPostUiRequestEmailLoginCodeResponse, ApiPostUiRequestEmailLoginCodeRequest>(
        "",
        API_POST_UI_REQUEST_EMAIL_LOGIN_CODE_URL,
        request,
        config
    );
    return result.data;
};

/**
 *
 */
export type ApiPostUiRequestEmailLoginCodeRequest = RequestEmailLoginCodeRequest;

/**
 * Description: Success
 */
export type ApiPostUiRequestEmailLoginCodeResponse = void;

interface RequestEmailLoginCodeRequest {
    authMethod: 1 | 2; // Auth method. Example: 1
    email?: string; // User's email. Example: agent@mail.com
    returnUrl?: string; // Return link. Example: /resolution-panel
}
